webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var oldGuests = [{ 'name': 'QasarYounis', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/qasar.png' }, { 'name': 'Ashish Sharma', 'title': 'Paytm', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ashish.png' }, { 'name': 'Vikas Banga', 'title': 'Snapdeal', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/vikas.png' }, { 'name': 'Ophir Gore', 'title': '以色列驻华使馆', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ophir.png' }, { 'name': 'Dovi Ollech', 'title': 'E.MERGR Fund', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/dovi.png' }, { 'name': 'Justin Kan', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/justin.png' }, { 'name': '张颖', 'title': '经纬中国', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhangying.png' }, { 'name': '朱啸虎', 'title': '金沙江创投', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhuxiaohu.png' }, { 'name': '戴威', 'title': 'ofo共享单车', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/daiwei.png' }, { 'name': '吴海燕', 'title': '华创资本', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/wuhaiyan2.png' }, { 'name': '宿华', 'title': '快手', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/suhua.png' }, { 'name': '肖文杰', 'title': '分期乐', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/xiaowenjie.png' }];
/* harmony default export */ __webpack_exports__["a"] = (oldGuests);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var util = {
    resource: function resource(options) {
        if (!options.data) {
            options.data = {};
        }
        if (!options.method) {
            options.method = 'get';
        }
        if (options.method == 'get') {
            options.data = {
                params: options.data
            };
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[options.method](options.url, options.data).then(function (res) {
            return res.json();
        }).then(function (res) {
            options.success(res);
        });
    },

    getWx: function getWx() {
        var _this = this;
        var data = {
            url: location.href,
            csrfmiddlewaretoken: $('.login-container input').val()
        };
        $.ajax({
            url: '/api/website/signature/weixin/',
            type: 'post',
            data: data,
            success: function success(res) {
                _this.callBack(res.data);
            }
        });
    },

    callBack: function callBack(data) {
        var wxurl = location.href;
        var wxtitle = "2019小饭桌全球青年创业者大会于11月26日隆重举办，全球顶级创投大佬分享创业经验，邀你一起探讨未来！";
        var wxdes = "举办时间：11月26日；会议地点：北京千禧酒店";
        var wximg = "https://static-miniapp.xfz.cn/xiaofanzhuologo.jpg";

        wx.config({
            debug: false,
            appId: data.app_id,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });
        wx.ready(function () {
            wx.onMenuShareTimeline({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                success: function success() {},
                cancel: function cancel() {}
            });
            wx.onMenuShareAppMessage({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                type: '',
                dataUrl: '',
                success: function success() {},
                cancel: function cancel() {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jim.f306a5e.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qasar.c4d0d5a.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuobuhua.3fbf07c.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xiaowenjie.31dbe60.png";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhangying.f290727.png";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/live-logo.730a805.png";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(53),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HomePc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TopSection: __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default.a,
    HomePc: __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default.a,
    HomeMobile: __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default.a
  },
  methods: {
    isPc: function isPc() {
      return screen.width > 650 ? true : false;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'index']
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgendaItem: __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default.a,
    TicketItem: __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default.a
  },
  data: function data() {
    return {
      whichDay: "Day1",
      showMenu: false,
      guestList: [],
      agendaData: {
        type: []
      },
      whichConf: "",
      whichHost: "",
      partnerList: [],
      currentAgendaMenu: [],
      activeAgendaMenu: "",
      currentAgendaData: [],
      showMoreFaq: false,
      showBottomNav: true,
      oldScrollY: 0,
      newScrollY: 0,
      oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
      ticketUrl: "https://www.xfz.cn/form/conference?acid=XaDLBoWpsm",
      newsUrl: "https://www.xfz.cn/explore/xfz2019/news/"
    };
  },

  methods: {
    addListenScroll: function addListenScroll() {
      var self = this;
      window.onscroll = function (e) {
        self.newScrollY = window.scrollY;
        if (self.newScrollY - self.oldScrollY > 0) {
          self.showBottomNav = false;
        } else {
          self.showBottomNav = true;
        }
        self.oldScrollY = self.newScrollY;
      };
    },
    getGuestData: function getGuestData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2019_api/guest/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.guestList = res.data;
          }
        }
      });
    },
    getPartnerData: function getPartnerData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2019_api/company/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.partnerList = res.data;
          }
        }
      });
    },
    getAgendaData: function getAgendaData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2019_api/meeting/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.agendaData = res.data;
            self.activeAgendaMenu = self.agendaData.type[0][0];
            self.changeCurrentAgenda(self.activeAgendaMenu, 0);
          }
        }
      });
    },
    changeCurrentAgenda: function changeCurrentAgenda(agenda) {
      this.activeAgendaMenu = agenda;
      this.currentAgendaData = this.agendaData.meeting[agenda];
      this.whichConf = agenda.split("|")[0];
      this.whichHost = agenda.split("|")[1];
    },
    gotoSection: function gotoSection(section) {
      $("html,body").animate({ scrollTop: $("#" + section).offset().top }, 1000);
    }
  },
  mounted: function mounted() {
    document.title = '2019小饭桌全球青年创业者大会！';
    this.addListenScroll();
    this.getGuestData();
    this.getAgendaData();
    this.getPartnerData();
    __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].getWx();
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        AgendaItem: __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default.a, TicketItem: __WEBPACK_IMPORTED_MODULE_1__TicketItem___default.a
    },
    data: function data() {
        return {
            showNav: true,
            showAgendaMenu: false,
            showAgendaMenu2: true,
            guestList: [],
            partnerList: [],
            agendaData: {
                meeting: {},
                type: []
            },
            whichConf: '',
            whichHost: '',
            currentAgendaData: [],
            activeAgendaMenu: '',
            activeAgendaMenuIndex: 0,
            showMoreFaq: false,
            oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
            ticketUrl: "https://www.xfz.cn/form/conference?acid=XaDLBoWpsm",
            newsUrl: "https://www.xfz.cn/explore/xfz2019/news/"
        };
    },

    methods: {
        getGuestData: function getGuestData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2019_api/guest/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.guestList = res.data;
                    }
                }
            });
        },
        getPartnerData: function getPartnerData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2019_api/company/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.partnerList = res.data;
                    }
                }
            });
        },
        getAgendaData: function getAgendaData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2019_api/meeting/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.agendaData = res.data;
                        self.activeAgendaMenu = self.agendaData.type[0][0];
                        self.changeCurrentAgenda(self.activeAgendaMenu, 0);
                    }
                }
            });
        },
        changeCurrentAgenda: function changeCurrentAgenda(agenda, index) {
            this.whichConf = agenda.split('|')[0];
            this.whichHost = agenda.split('|')[1];
            this.activeAgendaMenu = agenda;
            this.activeAgendaMenuIndex = index;
            this.currentAgendaData = this.agendaData.meeting[agenda];
        },
        gotoAgenda: function gotoAgenda(date) {
            location.href = "#s-agenda";
            if (date == 'date1') {
                this.changeCurrentAgenda(this.agendaData.type[0][0], 0);
            } else if (date == 'data2') {
                this.changeCurrentAgenda(this.agendaData.type[1][0], 4);
            }
        },
        gotoVipAgenda: function gotoVipAgenda(title) {
            this.whichConf = title.split('|')[0];
            this.whichHost = title.split('|')[1];
            this.changeCurrentAgenda(this.agendaData.type[0][4]);
        },
        listenScroll: function listenScroll() {
            var self = this;
            var offset = $('#participator-area').offset().top + 200;
            var flag = true;
            $(window).scroll(function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offset) {
                    if (flag) {
                        self.runCountUp();
                        flag = false;
                    }
                }
            });
        },
        runCountUp: function runCountUp() {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                suffix: '+'
            };
            var countup1 = new CountUp('countup-target1', 0, 3000, 0, 3.5, options);
            var countup2 = new CountUp('countup-target2', 0, 80, 0, 3.5, options);
            var countup3 = new CountUp('countup-target3', 0, 50, 0, 3.5, options);
            var countup4 = new CountUp('countup-target4', 0, 60, 0, 3.5, options);
            var countup5 = new CountUp('countup-target5', 0, 60, 0, 3.5, options);
            var countup6 = new CountUp('countup-target6', 0, 150, 0, 3.5, options);
            if (!countup1.error) {
                countup1.start();
                countup2.start();
                countup3.start();
                countup4.start();
                countup5.start();
                countup6.start();
            } else {
                console.error(demo.error);
            }
        }
    },
    mounted: function mounted() {
        document.title = '2019小饭桌全球青年创业者大会！';
        this.getGuestData();
        this.getPartnerData();
        this.getAgendaData();
        this.listenScroll();
    }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["data", "index"]
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(12);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/more.535e4b8.png";

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.128ba78.png";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.da50f9f.png";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-ceo.1b8669b.png";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-early-bird.61c49bb.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-experience.6dc5552.png";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-vip.43effcc.png";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bj_2_03.138a21f.png";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.ca743c2.png";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.725a72e.png";

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-ceo.8abd5bb.png";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-early-bird.73ae62b.png";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-experience.a5553a0.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ticket-vip.3b350a2.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-ee337162",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(24)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  "data-v-3f50cf71",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(52),
  /* scopeId */
  "data-v-20526fc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(26)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(56),
  /* scopeId */
  "data-v-50ae964f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-pc"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-summary"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('img', {
    staticClass: "menu-logo",
    attrs: {
      "src": __webpack_require__(32),
      "alt": ""
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#past-guest"
    }
  }, [_vm._v("往期嘉宾")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._v("参会购票")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guest-bg-area"
    }
  }, [_c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "guest-wrap-id"
    }
  }, [_c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "left-top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-bottom"
    })])])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "triangle-bg-area"
    }
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda"
  }, [_vm._m(5), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static-miniapp.xfz.cn/2019-agenda.png"
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "agenda-title-bottom"
  }), _vm._v(" "), _vm._l((_vm.agendaData.type[0]), function(type, index) {
    return [_c('div', {
      class: 'agenda-group-' + index
    }, [_c('div', {
      staticClass: "agenda-group-center",
      class: 'agenda-group-center-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'agenda-theme-' + index
    }, [(false) ? _c('div', {
      staticClass: "which-conf"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(type)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-map",
      attrs: {
        "href": "http://j.map.baidu.com/h4z9P",
        "target": "_blank"
      }
    }, [_vm._v("查看地图")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "agenda-list"
    }, [_vm._l((_vm.agendaData.meeting[type]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])])]
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tickets-bg-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(36),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(37),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(34),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.showMoreFaq) ? [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faq-more-btn",
    on: {
      "click": function($event) {
        _vm.showMoreFaq = !_vm.showMoreFaq
      }
    }
  }, [(!_vm.showMoreFaq) ? _c('span', [_vm._v("查看更多")]) : _c('span', [_vm._v("点击收起")])])], 2)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "partners-bg-area"
    }
  }, [_c('div', {
    staticClass: "section partners"
  }, [_c('p', {
    attrs: {
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }))]
    })]
  })], 2)])])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.newsUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-content"
  }, [_c('p', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-normal"
  }, [_vm._v("\n                  「全球青年创业者大会」已由小饭桌成功连续主办三届，目前已成为全球创投领域 TOP 级峰会。第四届2019「全球青年创业者大会」以“TRUST”为主题，并于11月26日在北京千禧大酒店举办。"), _c('br'), _vm._v("\n                    届时，大会将汇聚中国、硅谷、印度、自以色列、东南亚、日本等热门国家与地区的最佳大脑，以及中国大陆及港台地区的顶尖创投资源，共同描绘全球创业投资的发展趋势和蓝图，展现新消费、企业服务、产业互联网、出海等热门领域蓬勃发展的创投生态全景，打造年度精彩的青年创业者思想盛宴！")]), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" TRUST 相信，相信的力量！")]), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" 这是一个全新的时代，能看到多远的过去，就能看到多远的未来；")]), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" 这是一个可以标记你的时代，你对了，世界就对了! ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guest-title-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(31),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda-2"
  }, [_c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static-miniapp.xfz.cn/2019-agenda-2.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 大会议程 - 11/26 - 千禧酒店 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "award-content"
  }, [_c('a', {
    staticStyle: {
      "height": "200px",
      "width": "600px",
      "display": "block",
      "float": "right"
    },
    attrs: {
      "href": "https://www.xfz.cn/explore/2019vote/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "height": "200px",
      "width": "600px",
      "display": "block",
      "float": "right"
    },
    attrs: {
      "href": "https://www.xfz.cn/explore/2019vote/",
      "target": "_blank"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('div', {
    staticClass: "s-title",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会人群分析")])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参会嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target1"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("演讲嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target2"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会议嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target3"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("奖项数量")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target4"
    }
  }, [_vm._v("  0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参展企业")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target5"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target6"
    }
  }, [_vm._v(" 0+")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会购票 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" FAQ-参会指南 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票什么时候截止?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票截止日期为 2019年11月25日，中午12:00\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票付款成功后，如何获得参会凭证？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。"), _c('br'), _vm._v(" \n                            活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                            1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                            2) 开票内容为：会议服务费； "), _c('br'), _vm._v("\n                            3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会现场有同声传译服务吗？如何领取同传设备？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会场馆附近有就餐的地方吗？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh",
    staticStyle: {
      "margin": "40px auto 30px"
    }
  }, [_vm._v(" 合作机构 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('p', {
    attrs: {
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 会议地址 ")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        地铁10号线：金台夕照站 A口出，西行420米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        自驾：北京市朝阳区东三环中路七号，千禧大酒店\n                    ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://j.map.baidu.com/22/en",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section about-us"
  }, [_c('p', {
    attrs: {
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(" 联系我们 ")])]), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("赵子悠-Freya")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("185-4513-1578")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("zhaobo@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("张聪聪-Vincent")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("166-0112-4012")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("congcong@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注小饭桌")])])])])])
}]}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isPc()) ? _c('home-pc') : _c('home-mobile')], 1)
},staticRenderFns: []}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-mobile"
    }
  }, [_c('a', {
    attrs: {
      "name": "s-home",
      "id": "s-home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "just-a-wrap"
  }, [_vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "section-guest"
    }
  }, [_c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    })])])
  }))]), _vm._v(" "), _vm._m(3), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "agenda-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.agendaData.type[0]) ? _vm._l((_vm.agendaData.type[0]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [(false) ? _c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(key)
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(41),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), (_vm.showMoreFaq) ? [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faq-more-btn",
    on: {
      "click": function($event) {
        _vm.showMoreFaq = !_vm.showMoreFaq
      }
    }
  }, [(!_vm.showMoreFaq) ? _c('span', [_vm._v("查看更多")]) : _c('span', [_vm._v("点击收起")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "section partners"
  }, [_c('a', {
    attrs: {
      "name": "s-partners",
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "name": "s-partners"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "up-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }))]
    })]
  })], 2)])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBottomNav) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(39)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-wrap"
  }, [_c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v(" 邀请嘉宾 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v(" 大会议程 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._v(" 参会购票 ")]), _vm._v(" "), (false) ? _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "target": "_blank",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl
    }
  }) : _vm._e()])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "new-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.newsUrl
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }, [_c('div', {
    staticClass: "intro-content"
  }, [_c('div', {
    staticClass: "intro-normal"
  }, [_vm._v("\n                       「全球青年创业者大会」已由小饭桌成功连续主办三届，目前已成为全球创投领域 TOP 级峰会。第四届2019「全球青年创业者大会」以“TRUST”为主题，并于11月26日在北京千禧大酒店举办。"), _c('br'), _vm._v("\n                         届时，大会将汇聚中国、硅谷、印度、自以色列、东南亚、日本等热门国家与地区的最佳大脑，以及中国大陆及港台地区的顶尖创投资源，共同描绘全球创业投资的发展趋势和蓝图，展现新消费、企业服务、产业互联网、出海等热门领域蓬勃发展的创投生态全景，打造年度精彩的青年创业者思想盛宴！")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" TRUST 相信，相信的力量！")]), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" 这是一个全新的时代，能看到多远的过去，就能看到多远的未来；")]), _vm._v(" "), _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" 这是一个可以标记你的时代，你对了，世界就对了! ")])]), _vm._v(" "), _c('div', {
    staticClass: "guest-title-image"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PAST GUEST")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(30)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda-2"
  }, [_c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(38)
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static-miniapp.xfz.cn/2019-agenda-2.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 大会议程 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "award-content"
  }, [_c('a', {
    staticStyle: {
      "height": "100px",
      "width": "100%",
      "display": "block"
    },
    attrs: {
      "href": "https://www.xfz.cn/explore/2019vote/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "height": "100px",
      "width": "100%",
      "display": "block"
    },
    attrs: {
      "href": "https://www.xfz.cn/explore/2019vote/",
      "target": "_blank"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v("参会人员分析")])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参会嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 3000+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("演讲嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 80+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会议嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 50+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("奖项数量")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 60+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参展企业")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 60+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 150+")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会购票 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会指南 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票什么时候截止?\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票截止日期为2019年11月25日，中午12:00\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票付款成功后，如何获得参会凭证？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。"), _c('br'), _vm._v(" \n                                活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                                1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                                2) 开票内容为：会议服务费； "), _c('br'), _vm._v("\n                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会现场有同声传译服务吗？如何领取同传设备？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会场馆附近有就餐的地方吗？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 合作机构 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('a', {
    attrs: {
      "name": "s-location",
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 会议地址 ")])]), _vm._v(" "), _c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        地铁10号线：金台夕照站 A口出，西行420米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        自驾：北京市朝阳区东三环中路七号，千禧大酒店\n                    ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(40)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section about-us"
  }, [_c('a', {
    attrs: {
      "name": "s-contact-us",
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 联系我们 ")])]), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("赵子悠-Freya")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("185-4513-1578")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("zhaobo@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("张聪聪-Vincent")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("166-0112-4012")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("congcong@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注小饭桌")])])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-seciton"
    }
  }, [_vm._v("\n    hello top seciton         \n    "), _c('div', {
    staticClass: "test"
  }, [_vm._v("\n       test green \n    ")])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['agenda-item', {
      'agenda-item-bg-reverse': _vm.index % 2 == 0
    }]
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'one-width': _vm.data.speaker.length == 1 || _vm.data.speaker.length == 0, 'double-width': _vm.data.speaker.length == 2, 'triple-width': _vm.data.speaker.length == 3
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('div', {
    staticClass: "t-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[0]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[1]))])])]), _vm._v(" "), (_vm.data.subject.split('|')[0] == '圆桌论坛') ? _c('div', {
    staticClass: "a-content"
  }, [(_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('p', {
    staticClass: "bottom-title"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]) + " " + _vm._s(_vm.data.subject.split('|')[1]))])])]) : _c('div', {
    staticClass: "a-content"
  }, [(!_vm.data.speaker[0] || !_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "space"
  }) : _vm._e(), _vm._v(" "), (_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title"
  }, [_vm._v(" " + _vm._s(_vm.data.subject.split('|')[1]))])])])])])
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-agenda-item']
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'item-wrap-small': _vm.data.speaker.length == 0
    }
  }, [_c('div', {
    staticClass: "a-content"
  }, [_c('div', {
    staticClass: "a-content-wrap"
  }, [(_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name-title"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "t-name"
  }, [_vm._v(" " + _vm._s(_vm.data.time.split('~')[0]) + " - " + _vm._s(_vm.data.time.split('~')[1]) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[1]))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.265aaa521d46f377cbd8.js